import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingEditComponent } from './fi-onboarding-edit.component';
import { FiAccessRightFiltersModule } from '@fi-shared/access-right-filters';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { SideListModule } from '@fi-app/utilities/side-list/side-list.module';
import { MatCardModule } from '@angular/material/card';
import { FiNameDescriptionInputModule } from '@fi-app/shared/name-description-input/name-description-input.module';
import { FiEditorPageHeaderModule } from '@fi-app/shared/fi-editor-page-header/fi-editor-page-header.module';
import { FiTwoColumnsContainerModule } from '@fi-app/shared/fi-two-columns-container/fi-two-columns-container.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FiOnboardingEditorTabComponent } from './fi-onboarding-editor-tab/fi-onboarding-editor-tab.component';
import { FiTranslationRadioGroupModule } from '@fi-shared/fi-translation-radio-group/fi-translation-radio-group.module';
import { FiOnboardingSectionsListComponent } from './fi-onboarding-sections-list/fi-onboarding-sections-list.component';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { FiOnboardingSectionStepEditorComponent } from './fi-onboarding-section-step-editor/fi-onboarding-section-step-editor.component';
import { MatButtonModule } from '@angular/material/button';
import { FiInputAutoWidthModule } from '@fi-shared/fi-directives/fi-input-auto-width/fi-input-auto-width.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CdkDrag, CdkDragHandle, CdkDragPlaceholder, CdkDragPreview, CdkDropList } from '@angular/cdk/drag-drop';
import { FiOnboardingElementDropListHelperService } from './fi-onboarding-element-drop-list-helper.service';
import { FiOnboardingElementsCardComponent } from './fi-onboarding-elements-card/fi-onboarding-elements-card.component';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiElementObjectTypePickerSlideComponent } from './fi-onboarding-elements-card/element-object-type-picker-slide/element-object-type-picker-slide.component';
import { FiElementObjectTypeListComponent } from './fi-onboarding-elements-card/element-object-type-list/element-object-type-list.component';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiOnboardingConfirmDeleteItemDialogComponent } from './fi-onboarding-confirm-delete-item-dialog/fi-onboarding-confirm-delete-item-dialog.component';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiOnboardingSectionEditorComponent } from './fi-onboarding-section-editor/fi-onboarding-section-editor.component';
import { FiInfoBannerModule } from '@fi-shared/fi-info-banner/fi-info-banner.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiWhenScrolledModule } from '@fi-app/shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiOnboardingAutomatedNotificationDialogComponent } from './fi-onboarding-automated-notification-dialog/fi-onboarding-automated-notification-dialog.component';
import { FiOnboardingNotificationTabContentComponent } from './fi-onboarding-automated-notification-dialog/notification-tab-content/notification-tab-content.component';
import { FiOnboardingNotificationEditorDialogComponent } from './fi-onboarding-automated-notification-dialog/notification-editor-dialog/notification-editor-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { FiOnboardingAutomatedNotificationHelperService } from './fi-onboarding-automated-notification-dialog/fi-onboarding-automated-notification-helper.service';
import { FiSettingsSharingTabComponent } from './fi-settings-sharing-tab/fi-settings-sharing-tab.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FiOnboardingSharingSettingsComponent } from './fi-settings-sharing-tab/fi-sharing-settings/fi-sharing-settings.component';
import { FiOnboardingCategorySettingsComponent } from './fi-settings-sharing-tab/fi-category-settings/fi-category-settings.component';
import { FiOnboardingActivateSettingsComponent } from './fi-settings-sharing-tab/fi-activate-settings/fi-activate-settings.component';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiAutomatedActionRecipientSelectModule } from '@fi-app/shared/automated-action-recipient-select/automated-action-recipient-select.module';
import { FiOnboardingSharingRadioGroupComponent } from './fi-settings-sharing-tab/fi-sharing-settings/fi-onboarding-sharing-radio-group/fi-onboarding-sharing-radio-group.component';
import { FiOnboardingUserActivationDateFilterComponent } from './fi-settings-sharing-tab/fi-sharing-settings/fi-onboarding-user-activation-date-filter/fi-onboarding-user-activation-date-filter.component';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiOnboardingAccessRightSettingsComponent } from './fi-settings-sharing-tab/fi-sharing-settings/fi-onboarding-access-right-settings/fi-onboarding-access-right-settings.component';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAutomatedActionListItemModule } from '@fi-shared/automated-action-list-item/action-list-item.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiThreeColumnsContainerModule } from '@fi-app/shared/fi-three-columns-container/fi-three-columns-container.module';
import { FiOnboardingEditorGuideCardComponent } from './fi-onboarding-editor-guide-card/fi-onboarding-editor-guide-card.component';
import { FiProgressTimelineModule } from '@fi-app/shared/fi-progress-timeline/fi-progress-timeline.module';
import { FiOnboardingSharingSettingsGuideCardComponent } from './fi-onboarding-sharing-settings-guide-card/fi-onboarding-sharing-settings-guide-card.component';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FiAccessRightFiltersModule,
        FiAppTextSharedModule,
        FiSimpleContenteditableModule,
        FormsModule,
        MatCheckbox,
        MatRadioButton,
        MatRadioGroup,
        SideListModule,
        MatCardModule,
        FiNameDescriptionInputModule,
        FiEditorPageHeaderModule,
        FiTwoColumnsContainerModule,
        MatTabsModule,
        FiTranslationRadioGroupModule,
        MatIconModule,
        MatExpansionModule,
        MatMenuModule,
        MatDividerModule,
        MatButtonModule,
        FiInputAutoWidthModule,
        MatInputModule,
        MatFormFieldModule,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
        CdkDragPlaceholder,
        CdkDragPreview,
        InfoIconModule,
        FiLocalSearch2Module,
        FiMatIconCheckboxMenuModule,
        FiValidatingFormModule,
        FiInfoBannerModule,
        FiLoadingModule,
        FiWhenScrolledModule,
        MatSelectModule,
        MatButtonToggleModule,
        FiToggleSwitchModule,
        FiDatePickerModule,
        FiAutomatedActionRecipientSelectModule,
        FiTooltipModule,
        InfoIconModule,
        FiIconTooltipButtonModule,
        FiProfileIconModule,
        FiAutomatedActionListItemModule,
        FiEmptyListModule,
        FiThreeColumnsContainerModule,
        FiProgressTimelineModule,
        FiNameInputModule,
    ],
    declarations: [
        FiOnboardingEditComponent,
        FiOnboardingEditorTabComponent,
        FiOnboardingSectionsListComponent,
        FiOnboardingSectionStepEditorComponent,
        FiOnboardingElementsCardComponent,
        FiElementObjectTypePickerSlideComponent,
        FiElementObjectTypeListComponent,
        FiOnboardingConfirmDeleteItemDialogComponent,
        FiOnboardingSectionEditorComponent,
        FiOnboardingAutomatedNotificationDialogComponent,
        FiOnboardingNotificationTabContentComponent,
        FiOnboardingNotificationEditorDialogComponent,
        FiSettingsSharingTabComponent,
        FiOnboardingSharingSettingsComponent,
        FiOnboardingCategorySettingsComponent,
        FiOnboardingActivateSettingsComponent,
        FiOnboardingSharingRadioGroupComponent,
        FiOnboardingUserActivationDateFilterComponent,
        FiOnboardingAccessRightSettingsComponent,
        FiOnboardingEditorGuideCardComponent,
        FiOnboardingSharingSettingsGuideCardComponent,
    ],
    exports: [FiOnboardingSectionsListComponent],
    providers: [FiOnboardingElementDropListHelperService, FiOnboardingAutomatedNotificationHelperService],
})
export class FiOnboardingEditModule {}
